import { apiSlice } from "../../../_api/apiSlice";
import { apiRoutes } from "../../../_config/apiRoutes";

/**
 * Backs the sidebar nav's per-item badge counts - see
 * `../config/dashboardNavigation.js`'s own header comment for why these
 * used to be static placeholder strings, and `controllers/navCounts.
 * controller.js` (simplifyserver) for what each field actually counts.
 */
export const navCountsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNavCounts: builder.query({
      query: () => ({
        url: apiRoutes.navCounts.path,
        method: apiRoutes.navCounts.reqType,
      }),
    }),
  }),
});

export const { useGetNavCountsQuery } = navCountsApi;
